import React from "react";
import "../assets/styles/about.css";

const About = () => {
  return (
    <div className="about-container">
      {/* Hero Section */}
      <section className="about-hero">
        <h1>About SeeingMoney</h1>
        <p>
          At SeeingMoney, we transform personal finance into a visual journey.
          Our mission is to make money management intuitive and engaging by
          leveraging powerful visuals and interactive tools that bring financial
          concepts to life.
        </p>
      </section>

      {/* Mission Section */}
      <section className="about-mission">
        <h2>Our Mission</h2>
        <p>
          We simplify financial literacy by turning complex concepts into
          easy-to-understand charts, graphs, and illustrations. Whether you’re
          planning for retirement, saving for a goal, or just starting your
          financial journey, we’re here to make the path clear and empowering.
        </p>
      </section>

      {/* Values Section */}
      <section className="about-values">
        <h2>Our Core Values</h2>
        <ul>
          <li>
            <strong>Clarity:</strong> We believe visuals have the power to make
            even the most complex topics simple and actionable.
          </li>
          <li>
            <strong>Empowerment:</strong> By presenting data visually, we put
            you in control of your financial future.
          </li>
          <li>
            <strong>Accessibility:</strong> We aim to make financial knowledge
            available and relatable for everyone, regardless of expertise.
          </li>
        </ul>
      </section>
    </div>
  );
};

export default About;
